import initSentry from '@zocdoc-frontend-common/sentry-config';

export function doSentryInit() {
    const { SENTRY_DSN, RELEASE, CLEARDATA_API_HOST, PAGE_ID } =
        window && window.ZD ? window.ZD.configs : {};

    if (SENTRY_DSN) {
        // client-side error reporting
        // https://docs.sentry.io/error-reporting/quickstart/?platform=browser

        const sentryOpts = {
            dsn: SENTRY_DSN,
            release: RELEASE,
        };

        initSentry(sentryOpts, {
            appName: 'booking-web-app',
            pageviewId: PAGE_ID,
            loggingApiHost: CLEARDATA_API_HOST,
        });
    }
}
